import { render, staticRenderFns } from "./Applicant.vue?vue&type=template&id=66692bec&scoped=true&"
import script from "./Applicant.vue?vue&type=script&lang=js&"
export * from "./Applicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66692bec",
  null
  
)

export default component.exports